/** 协议弹窗：moduleID */
export const TP_AGREEMENT_POPUP_MODULE = 'finance_loan_agreementPopUp';
